var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"ghost":"","small":""},on:{"click":_vm.confirmDelete}},[_vm._v(" Delete ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }